import { useNavigate } from 'react-router-dom'
import classnames from 'classnames'

import Button from 'src/ui/atoms/Button'

export interface ICard {
  title: string
  installs: string
  icon: string
  icons: string[]
  route: string
  dataCy?: string
  live: boolean
}

const Card = ({ title, installs, icon, icons, route, dataCy, live }: ICard) => {
  const navigate = useNavigate()

  return (
    <div
      className={classnames('grid gap-6 rounded-lg p-6 text-white', {
        'bg-navy-blue': live,
        'bg-dark-gray': !live,
      })}>
      <span className="flex items-center justify-between">
        <span
          className={classnames(
            `h-12 w-12 rounded-lg text-center leading-[48px] icon-${icon} bg-white bg-opacity-20 text-xl`,
            {
              'text-main-blue': live,
              'text-gray': !live,
            },
          )}></span>
        <span className="text-sm font-normal">{installs}</span>
      </span>
      <h2 className="mt-6 md:mt-14">{title}</h2>
      <span className="flex items-center justify-between">
        <span className="grid grid-flow-col gap-2">
          {icons.map((smallIcon, key) => (
            <span key={key} className={`icon-${smallIcon} text-xl text-white`}></span>
          ))}
        </span>
        <Button
          name={live ? 'Create' : 'Soon'}
          disabled={!live}
          size="M"
          data-cy={dataCy}
          onClick={() => navigate(route)}
        />
      </span>
    </div>
  )
}

export default Card
